import { Link } from "react-router-dom";
import {
  BookOpenIcon,
  UserCircleIcon,
  ChevronLeftIcon,
} from "@heroicons/react/24/outline";
import PageHeader from "../../components/layout/PageHeader";

const sections = [
  {
    title: "AC Book Entry",
    desc: "Bulk-enter ACs from returned paper books by term, activity, and cabin.",
    icon: BookOpenIcon,
    to: "/admin/manage-acs/book-entry",
    color: "bg-indigo-100 text-indigo-700",
  },
  {
    title: "Camper AC Entry",
    desc: "Quickly review and enter all ACs earned by a single camper across any year.",
    icon: UserCircleIcon,
    to: "/admin/manage-acs/camper-entry",
    color: "bg-sky-100 text-sky-700",
  },
];

export default function ManageACs() {
  return (
    <div>
      <PageHeader
        title="Manage ACs"
      />

      <div className="p-6 lg:p-8">
        <Link
          to="/admin"
          className="inline-flex items-center gap-1.5 text-sm text-stone-500 hover:text-stone-800 mb-6"
        >
          <ChevronLeftIcon className="w-4 h-4" />
          Back to Admin
        </Link>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-2xl">
          {sections.map((section) => {
            const Icon = section.icon;
            return (
              <Link key={section.to} to={section.to} className="camp-card p-6 block group">
                <div
                  className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${section.color}`}
                >
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-semibold text-stone-900 group-hover:text-forest-700 transition-colors">
                  {section.title}
                </h3>
                <p className="text-sm text-stone-500 mt-1">{section.desc}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
